<template>
  <BaseNotificationDialog :is-open="!!nextNotification">
    <template v-if="nextNotification">
      <div
        class="mb-4 flex w-full items-center justify-between"
      >
        <IconBrandLogo class="h-auto w-[12.5rem]" />
        <button
          type="button"
          @click="onDismiss(nextNotification)"
        >
          <IconX />
        </button>
      </div>

      <NotificationContent
        class="flex-1 overflow-y-auto pr-2"
        :content="nextNotification.contents"
      />
    </template>
  </BaseNotificationDialog>
</template>

<script setup lang="ts">
import {
  type RetrieveNextNotificationResponse,
  useNextNotification,
} from "@/services/notifications/retrieveNextNotification"
import { viewNotification } from "@/services/notifications/viewNotification"
import { IPreferences } from "@/androidPlugins/IPreferences"

const lastSeenId = ref<string | null>()
onMounted(async () => {
  const { value } = await IPreferences.get({
    key: "lastSeenNotification",
  })
  lastSeenId.value = value
})

const setLastSeenId = async (value: string) => {
  lastSeenId.value = value
  await IPreferences.set({
    key: "lastSeenNotification",
    value: value,
  })
}

const { data: nextNotification } = useNextNotification(
  computed(() => ({ lastSeenId: lastSeenId.value }))
)

const onDismiss = async (
  notification: RetrieveNextNotificationResponse
) => {
  await setLastSeenId(notification.id)
  await viewNotification(notification.id)
}
</script>
